import styled from 'styled-components';

export const Modal = styled.div``;
